import { MobXProviderContext, observer } from "mobx-react"
import * as React from "react"
import * as InfiniteScroll from "react-infinite-scroller"
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { GroupCard, MUIBlock, MUIPreloader } from "../../MUI";
import { ICoursesGroup } from "../types";
import * as Cookies from "js-cookie";
import FSCourseslistStore from "./store";
import FSStore from "../store";
import { Box, Button } from "@material-ui/core";
import { tl } from "../../../../utils";


const CoursesListError: React.FC<{onClick: () => void | Promise<any>}> = () => (
  <MUIBlock>
    <Box mb={2}>{tl("Произошла ошибка. Попробуйте повторить позднее.")}</Box>
    <Button variant="contained" color="primary" onClick={() => {}}>
      {tl("Обновить страницу")}
    </Button>
  </MUIBlock>
);

interface GroupsListProps {
  // error: string | boolean;
  // groups: Array<ICoursesGroup>;
  // isWidget: boolean;
  // hasMore: boolean;
  // module: string;
}

export const GroupsList: React.FC<GroupsListProps> = observer(({
}) => {
  const { fsStore, fsCourseslistStore } = React.useContext<{
    fsStore: FSStore
    fsCourseslistStore: FSCourseslistStore
  }>(MobXProviderContext);

  const lastActiveGroup = React.useMemo(() => Number(Cookies.get('lastGroup')),[]);
  const handleErrorClick = () => {
    fsCourseslistStore.page = 1;
    fsCourseslistStore.getGroupsList();
  }
  
  return (
    <>
      {!fsCourseslistStore.error && fsCourseslistStore.groups.length && !fsCourseslistStore.isLoading? (
        <InfiniteScroll
          useWindow={!fsStore.isWidget}
          loadMore={() => fsCourseslistStore.getGroupsNext()}
          hasMore={!fsCourseslistStore.isLoadingNext && fsCourseslistStore.hasMoreGroups}
        >
          {fsCourseslistStore.groups.map((group) => (
            <GroupCard
              isExtended={group.id === lastActiveGroup}
              group={group}
              onCourseClick={fsStore.onChangeCourse}
              module={fsStore.module}
              key={`fs-courseslist-course-${group.id}`}
            />
          ))}
          {fsCourseslistStore.isLoadingNext && <MUIPreloader key="filestorage-courseslist-preloader" />}
        </InfiniteScroll>
      ) : fsCourseslistStore.isLoading ? (
        <MUIPreloader />
      ) : fsStore.isWidget ? (
        fsCourseslistStore.error ? (
          <CoursesListError onClick={() => handleErrorClick()} />
        ) : (
          <Box px={2} py={3} textAlign="center">
            {tl("Курсов не найдено.")}
          </Box>
        )
      ) : (
        <MUIBlock>
          {fsCourseslistStore.error ? <CoursesListError onClick={handleErrorClick} />: tl("Курсов не найдено.")}
        </MUIBlock>
      )}
    </>
  )
})